var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFoldedHands(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFD764",
    d: "M13.152.965C12.907.38 12.334 0 11.7 0s-1.206.38-1.451.965c-.02.044-.033.09-.04.137L7.846 15.265 5.64 16.92c-.14.104-.226.264-.238.437-.013.174.05.344.174.467l4.2 4.2c.21.211.545.235.784.056l2.4-1.8c.151-.113.24-.291.24-.48V1.2c0-.08-.016-.16-.048-.235z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#43A6DD",
    d: "M10.624 21.776l-4.8-4.8c-.182-.183-.461-.228-.692-.113l-4.8 2.4c-.204.102-.332.31-.332.537v6c0 .331.269.6.6.6H6c.143 0 .282-.051.39-.145l4.2-3.6c.127-.108.203-.265.21-.432.006-.167-.058-.329-.176-.447z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFD764",
    d: "M20.76 16.92l-2.207-1.656-2.361-14.16c-.008-.047-.021-.093-.04-.137-.246-.585-.818-.965-1.452-.965s-1.207.38-1.452.965c-.031.073-.048.153-.048.233v18.6c0 .189.089.367.24.48l2.4 1.8c.239.18.573.155.784-.056l4.2-4.2c.123-.123.187-.293.174-.467-.012-.173-.099-.333-.238-.437z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#43A6DD",
    d: "M26.068 19.26l-4.8-2.4c-.23-.115-.51-.07-.692.113l-4.8 4.8c-.118.118-.182.28-.175.447.006.167.082.324.209.432l4.2 3.6c.108.095.246.147.39.148h5.4c.331 0 .6-.269.6-.6v-6c.001-.228-.127-.438-.332-.54z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E2AC4B",
    d: "M13.2 19.8c-.331 0-.6-.269-.6-.6V1.8c0-.331.269-.6.6-.6.331 0 .6.269.6.6v17.4c0 .331-.269.6-.6.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFoldedHands);
export default __webpack_public_path__ + "static/media/icon_folded_hands.df4bf6bda8b715c3cec6bd4706f0cbfe.svg";
export { ForwardRef as ReactComponent };